import LandingImagePng from '@assets/landing-image.png';
import BaseContainer from '@components/common/atoms/container/BaseContainer';
import RestaurantCitySelector from '@components/offer/components/city/RestaurantCitySelector';
import { Box, Grid } from '@mui/material';
import React from 'react';
import UserNotLoggedIn from "../../common/molecules/UserNotLoggedIn";

interface LandingProps {
}

const Landing: React.FC<LandingProps> = ({ }) => {
    return (
        <Box
            sx={{
                backgroundImage: `url(${LandingImagePng})`,
                // backgroundColor: (theme) => theme.palette.primary.main,
                backgroundPosition: "center",
                backgroundSize: "cover",
                mt: { xs: "-72px", sm: "-80px", md: "-96px", lg: "-112px" },
                mb: { xs: 4, sm: 6 },
            }}
            width={"100vw"}
            marginLeft={"calc(50% - 50vw)"}>
            <Grid
                sx={{
                    backdropFilter: { xs: "blur(16px)", },
                    // backgroundColor: "#ffffffbf"
                    // backgroundColor: "#777777bf",
                    backgroundColor: "#393939d6"
                }}
                pt={{ xs: "72px", sm: "80px" }}
                // pb={2}
                container
                direction={"column"}
                alignItems={"center"}
                width={"100%"}>
                <BaseContainer>
                    <Box
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        flexDirection={"column"}
                        gap={3}
                        pt={{ xs: 4, md: 8, lg: 8 }}
                        pb={{ xs: 10, md: 10, lg: 12 }}
                        sx={(theme) => ({
                            [theme.breakpoints.down('md')]: {
                                // flexWrap: "wrap",
                            },
                        })}>

                        <UserNotLoggedIn textColor='#fff'/>

                        <Box
                            width={{ xs: "100%", md: "100%", maxWidth: "780px" }}
                            display={"flex"}
                            justifyContent={{ xs: "center", md: "flex-start" }}
                            alignItems={"flex-start"}
                            textAlign={"center"}>
                            <RestaurantCitySelector />
                        </Box>
                    </Box>
                </BaseContainer>
            </Grid>
        </Box>

    )
}

export default Landing;